import {
	trigger,
	state,
	style,
	transition,
	animate
} from '@angular/animations';

export const pageTransitions = [
	trigger('routeAnimation', [
		state('*', style({ transform: 'scale(1)', opacity: 1 })),
		transition('void => *', [
			style({ transform: 'scale(0.95)', opacity: 0 }),
			animate('300ms cubic-bezier(0.0, 0.0, 0.2, 1)')
		]),
		transition('* => void', [
			style({ zIndex: -1 }),
			animate('0ms 300ms', style({ zIndex: -1 }))
		])
	]),
	trigger('initialRouteAnimation', [
		transition('void => *', []),
		transition('* => void', [
			style({ zIndex: -1 }),
			animate('0ms 300ms', style({ zIndex: -1 }))
		])
	]),
	trigger('bubbleAnimation', [
		state('*', style({ opacity: 1 })),
		transition('void => *', [
			style({ opacity: 0 }),
			animate('250ms cubic-bezier(0.0, 0.0, 0.2, 1)')
		]),
		transition('* => void', [animate('200ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 0 }))])
	]),
];
